import React from "react";
import { motion } from "framer-motion";
import { Trophy, Sparkles, Eye, Zap, Users, Gauge, Target, Layers } from "lucide-react";

const reasons = [
  { icon: Trophy, title: "ROI Focused", desc: "Every rupee tracked. Every campaign measured. Maximum returns, always." },
  { icon: Sparkles, title: "Premium Media", desc: "Access to quality inventory & 300+ vetted publishers for better reach." },
  { icon: Eye, title: "Transparent", desc: "Clear updates, real-time reporting, complete visibility on every spend." },
  { icon: Zap, title: "Fast Execution", desc: "Agile teams, quick turnarounds — from strategy to launch in days." },
  { icon: Users, title: "Dedicated Support", desc: "Senior campaign managers, always with you. No handoffs, no ticketing." },
  { icon: Gauge, title: "Enterprise Reporting", desc: "Real-time dashboards & smart insights delivered where you need them." },
  { icon: Target, title: "Advanced Targeting", desc: "Right audience, right time — built on years of first-party data." },
  { icon: Layers, title: "Multi-Channel", desc: "Integrated execution across paid, social, email, SMS, PR & offline." },
];

export default function WhyChoose() {
  return (
    <section className="relative py-32 bg-[#070707] border-y border-white/5">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-14">
          <div className="lg:col-span-5">
            <span className="eyebrow-emerald">Why Choose SYR</span>
            <h2 className="mt-6 text-4xl md:text-6xl font-semibold leading-tight">
              Beyond marketing. <br /><span className="text-emerald-gradient">We build</span> <span className="text-gold-gradient">digital businesses.</span>
            </h2>
            <p className="mt-6 text-white/60 text-lg leading-relaxed">
              SYR Mediaworks is more than a digital agency. We partner with ambitious
              businesses to build powerful brands through AI, custom software, performance
              marketing, branding, automation and next-generation digital solutions that
              create measurable business growth.
            </p>

            <div className="mt-10 glass-gold rounded-3xl p-8">
              <div className="serif text-3xl md:text-4xl leading-snug text-[#F4D983]">
                “Turning ideas into industry leaders.”
              </div>
              <div className="mt-4 text-xs uppercase tracking-[0.28em] text-white/50">
                Our commitment to every partner
              </div>
            </div>
          </div>

          <div className="lg:col-span-7 grid sm:grid-cols-2 gap-4">
            {reasons.map((r, i) => (
              <motion.div
                key={r.title}
                initial={{opacity:0, y:20}}
                whileInView={{opacity:1, y:0}}
                viewport={{once:true}}
                transition={{duration:0.5, delay: (i%4)*0.06, ease:[0.16,1,0.3,1]}}
                className="card-lift glass rounded-2xl p-6"
              >
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 rounded-lg border border-[#C9A227]/30 bg-[#C9A227]/5 grid place-items-center shrink-0">
                    <r.icon size={17} className="text-[#F4D983]" />
                  </div>
                  <div>
                    <div className="font-semibold">{r.title}</div>
                    <div className="text-sm text-white/55 mt-1.5 leading-relaxed">{r.desc}</div>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
